import { Injectable, inject } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise, tap } from 'rxjs';
import { logger } from '../pbir/utils/logger';

const LOGGER = logger('ReturnUrl');

@Injectable({
  providedIn: 'root'
})
export class ReturnUrl {
  readonly router = inject(Router);

  readonly _ = this.router.events.pipe(
    filter(e => e instanceof RoutesRecognized),
    pairwise(),
    tap(([e,]) => {
      this.stack.push(e.urlAfterRedirects);
    })
  );

  private stack = [];

  async navigate(options?: { fallback?: string }): Promise<boolean> {
    let returnUrl = this.stack.length ? this.stack[this.stack.length - 1] : options?.fallback;
    if (!returnUrl) {
      LOGGER.error(`[ReturnUrl] Tried to navigate, but the stack is empty.`);
      return;
    }

    if ((await this.router.navigateByUrl(returnUrl))) {
      this.stack.pop();
      return true;
    }

    return false;
  }

  clear() {
    this.stack = [];
  }

  push(url: string) {
    this.stack.push(url);
  }
}
